<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
  @import "@/assets/scss/vuexy/pages/customBackgrounds.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button @click="goToAdd()" class="bg-primary float-right" type="filled">{{$t("Labels.Add")}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/4 w-full">
        <label>{{$t('Labels.From')}}</label>
        <datepicker class="w-full" :value="filter.from" v-model="filter.from" name="from"></datepicker>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <label>{{$t('Labels.To')}}</label>
        <datepicker class="w-full" :value="filter.to" v-model="filter.to" name="to"></datepicker>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <label>{{$t('Labels.Type')}}</label>
        <v-select :options="types" v-model="filter.type" :reduce="org => org.value" label="label"/>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-button class="mt-6" @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
          <label>{{$t('Labels.Company')}}</label>
          <v-select :options="companies" v-model="filter.company_uuid" :reduce="org => org.uuid" label="name"/>
      </div>
      <div class="vx-col md:w-1/3 w-full">
          <label>{{$t('Labels.Status')}}</label>
          <v-select :options="statusOptions" v-model="filter.status" :reduce="org => org.value" label="label"/>
      </div>
    </div>
    <vs-table v-if="response" :data="response"
      @selected="goToDetail">
      <template slot="thead">
        <vs-th sort-key="begin_at">
          {{$t('Labels.Start')}}
        </vs-th>
        <vs-th sort-key="expire_at">
          {{$t('Labels.Expire')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.Validity')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.TimeToExpire')}}
        </vs-th>
        <vs-th sort-key="company">
          {{$t('Labels.Company')}}
        </vs-th>
        <vs-th sort-key="count_devices">
          {{$tc('Labels.Device',2)}}
        </vs-th>
        <vs-th sort-key="status">
          {{$t('Labels.Status')}}
        </vs-th>
      </template>

      <template  slot-scope="{data}">
        <vs-tr :data="item" :key="index" v-for="(item, index) in data" :class="getColor(item.begin_at,item.expire_at)">
          <vs-td :data="item.begin_at">
            {{item.begin_at}}
          </vs-td>
          <vs-td :data="item.expire_at">
            {{item.expire_at}}
          </vs-td>
          <vs-td>
            {{getValidity(item.begin_at,item.expire_at)}}
          </vs-td>
          <vs-td>
            {{timeToExpire(item.expire_at)}}
          </vs-td>
          <vs-td :data="item.company">
            {{item.company.name}}
          </vs-td>
          <vs-td :data="item.count_devices">
            {{item.count_devices}}
          </vs-td>
          <vs-td :data="item.status">
            <span v-if="item.status == 'C'" class="p-2 rounded bg-success text-white">{{$t('Labels.Created')}}</span>
            <span v-if="item.status == 'A'" class="p-2 rounded bg-success text-white">{{$t('Labels.Asigned')}}</span>
            <span v-if="item.status == 'Ac'" class="p-2 rounded bg-success text-white">{{$t('Labels.Active')}}</span>
            <span v-if="item.status == 'I'" class="p-2 rounded bg-grey text-white">{{$t('Labels.Inactive')}}</span>
            <span v-if="item.status == 'E'" class="p-2 rounded bg-red text-white">{{$t('Labels.Expired')}}</span>
          </vs-td>
        </vs-tr>
      </template>


    </vs-table>
    <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
  </div>
</template>

<script>
import {request} from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    listItem,
    vSelect,
    Datepicker
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      active:false,
      totalPages: 0,
      oldCurrentPage: 1,
      filter:{
        limit:1000,
        offset:0,
        byColumn:'begin_at',
        byOrder:'asc',
        company_uuid: this.$route.query.company,
        from: Date(),
        to:Date(),
        status: ''
      },
      selected: {},
      companies:[],
      types:[
        {
          value: '',
          label: this.$t('Labels.All')
        },
        {
          value: 'begin_at',
          label: this.$t('Labels.Start')
        },
        {
          value: 'expire_at',
          label: this.$t('Labels.Expire')
        }
      ],
      statusOptions:[
        {
          value: '',
          label: this.$t('Labels.All')
        },
        {
          value: 'A',
          label: this.$t('Labels.Active')
        },
        {
          value: 'I',
          label: this.$t('Labels.Inactive')
        },
        {
          value: 'E',
          label: this.$t('Labels.Expired')
        }
      ]
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getCompanies () {
      this.$vs.loading()
      const params = {
        url: 'companies',
        method: 'GET',
        params:{
          limit:10000,
          offset:0,
          byColumn:'name',
          byOrder:'asc'
        }
      }
      await request(params).then(response => {
        this.companies = response.data.data.rows
        this.companies.unshift({
          uuid:0,
          name: this.$t('Labels.All')
        })
        this.filter.company_uuid = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'licenses',
        method: 'GET',
        params: this.filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.totalPages = response.data.data.count
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    goToDetail (tr) {
      window.location.href = `/licenses/${tr.uuid}`
    },
    goToAdd () {
      window.location.href = '/licenses/add'
    },
    getValidity (start, expire) {
      const s = this.$dayjs(start)
      const e = this.$dayjs(expire)

      return this.$dayjs.duration(e.diff(s)).humanize()
    },
    timeToExpire (expire) {
      if (this.$dayjs() > this.$dayjs(expire)) return 0
      const s = this.$dayjs()
      const e = this.$dayjs(expire)
      return this.$dayjs.duration(e.diff(s)).humanize()
    },
    getColor (start, expire) {
      const s = this.$dayjs(start)
      const e = this.$dayjs(expire)
      const today = this.$dayjs()
      const totalDays = this.$dayjs.duration(e.diff(s)).as('days')
      const toExpireDays = this.$dayjs.duration(e.diff(today)).as('days')
      const percent = (toExpireDays * 100) / totalDays
      if (percent > process.env.VUE_APP_PERCENT_SUCCESS) return 'bg-success-light'
      else if (percent > process.env.VUE_APP_PERCENT_WARNING) return 'bg-warning-light'
      else return 'bg-danger-light'
    }
  },

  created () {
    /*this.$route.meta.breadcrumb[1].title = this.$t('Path.Licenses')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.List')
    this.$route.meta.pageTitle = this.$t('Path.List')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})*/
    this.getCompanies()
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  },

  updated () {
    if (this.oldCurrentPage != this.currentx) {
      this.oldCurrentPage = this.currentx
      this.getActualizar()
    }
  }
}
</script>
